import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ILoginCustomization, SessionService } from 'pod-ng-core';

import { environment } from '../../environments/environment';
import { ThemeService } from 'src/services/theme.service';
import { Observable } from 'rxjs';
import { pluck } from 'rxjs/operators';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
})
export class LoginComponent implements OnInit {
  public environment = environment;
  private oLoginCustomization: Observable<ILoginCustomization>;
  public loginCustomization: ILoginCustomization;

  constructor(
    private activatedRoute: ActivatedRoute,
    private themeService: ThemeService,
    private session: SessionService
  ) {
    this.oLoginCustomization = this.activatedRoute.data.pipe(
      pluck('loginCustomization')
    );
    if (this.oLoginCustomization) {
      this.oLoginCustomization.subscribe(data => {
        this.themeService.setThemeById(
          data.theme || this.session.getAccountTheme()
        );
        this.themeService.setFavicon(
          data.favicon || this.session.getAccountFavicon()
        );
        this.themeService.setSiteKey(
          data.siteKey || this.session.getAccountSiteKey()
        );
        this.loginCustomization = data;
      });
    }
  }

  ngOnInit() {
    // reset login status
    this.session.logout();
  }
}
